import { writable } from "svelte/store";

export const pokemonStore = writable([]);
